import { HttpClient } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { HelperService } from 'app/core/services/helper/helper.service';
import { BrandTermsService } from 'app/modules/admin/brand-terms/brand-terms.service';
import { map, Subject } from 'rxjs';
import { BrandItemPopupService } from './brand-item-popup.service';

@Component({
  selector: 'app-brand-term-popup',
  standalone: true,
  imports: [],
  templateUrl: './brand-term-popup.component.html',
  styleUrl: './brand-term-popup.component.scss'
})
export class BrandTermPopupComponent {
  details: any;
  reqData: { version: string; ipAddress: any; userAgent: string; isAccpted: boolean; brandTermsId: string; };
  constructor(private eventService: BrandItemPopupService,private _apiService: BrandTermsService, private http: HttpClient, private _helper: HelperService,public dialogRef: MatDialogRef<BrandTermPopupComponent>,
          @Inject(MAT_DIALOG_DATA) public data: any){
      
  }

  ngOnInit(){
    this.getUserAgent();
  }


  getDetails() {
        this._apiService.viewActive().subscribe((res: any) => {
            if (res?.meta?.status == 1) {
              this.details = res?.data;
            } else {
                this._helper.toast(res?.meta?.message, 'error');
            }
        });
    }

    async getUserAgent(){
      this.reqData = {
        "version": this.data?.version,
        "ipAddress": await this.getIp(),
        "userAgent": navigator?.userAgent,
        "isAccpted": true,
        "brandTermsId": this.data?.brandTermsId
      }
    }

    async getIp(): Promise<string> {
      const res = await this.http
        .get<{ ip: string }>('https://api.ipify.org?format=json')
        .toPromise();

      return res?.ip ?? '';
    }

  accept(){
      this._apiService.acceptBrandTerm(this.reqData).subscribe(
        (res: any) => {
            if (res?.meta?.status == 1) {
                this.dialogRef.close();
                this._helper.toast(res?.meta?.message, 'success');
                localStorage.setItem("brandTermAccepted",'true')
                this.eventService.trigger({ refresh: true });
            }else{
                this._helper.toast(res?.meta?.message, 'error');
            }
        });
    }

    closePopup(data?: any) {
      this.dialogRef.close(data);
      localStorage.setItem("brandTermAccepted",'false')
      this.eventService.trigger({ refresh: true });
    }
}
